import { testimonials } from '@/mocks/data';

export default function Testimonials() {
  return (
    <section id="testimonials" className="mb-14 py-10 px-6 rounded-xl bg-background-200/20 border border-background-200/20">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading mb-8 text-center">
        用户口碑
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="p-5 rounded-lg bg-background-200/40 border border-background-200/20"
          >
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: t.rating }).map((_, j) => (
                <div key={j} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-primary-400 text-sm"></i>
                </div>
              ))}
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              &ldquo;{t.content}&rdquo;
            </p>
            <div className="flex items-center gap-3">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-10 h-10 rounded-full object-cover"
                loading="lazy"
              />
              <span className="text-sm font-medium text-foreground-200">{t.name}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}